import React from 'react';
import styles from './style.module.scss';
import ReviewHeader from '../common/ReviewHeader';
import equipmentPlaceholderImg from '../../../../../../../../../../images/v2/equipment_placeholder.png';

// Mock data for testing
const MOCK_DATA = {
  purchases: [
    {
      model: 'Dejavoo QD4',
      quantity: 1,
      price: 760.00,
      image: '/img-equipment/dejavoo-qd4'
    },
    {
      model: 'PAX A80',
      quantity: 2,
      price: 550.00,
      image: '/img-equipment/pax-a80'
    }
  ],
  monthlyCosts: [
    {
      model: 'Dejavoo Z8',
      quantity: 1,
      price: 25.00,
      type: 'rent',
      image: '/img-equipment/dejavoo-z8'
    },
    {
      model: 'PAX A290',
      quantity: 2,
      price: 35.00,
      type: 'lease',
      image: '/img-equipment/pax-a290'
    }
  ],
  tppHardware: [
    {
      model: 'Dejavoo Z9',
      quantity: 1,
      price: 450.00,
      image: '/img-equipment/dejavoo-z9'
    }
  ]
};

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
};

const SectionHeader = ({ title }) => (
  <div className={styles.sectionHeader}>
    <span className={styles.sectionTitle}>{title}</span>
    <div className={styles.sectionLine} />
  </div>
);

const EquipmentItem = ({ item }) => (
  <div className={styles.detailItem}>
    <div className={styles.detailValue}>
      <div className={styles.equipmentInfo}>
        <div className={styles.equipmentThumbnail}>
          <img 
            src={equipmentPlaceholderImg}
            alt={item.model} 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = equipmentPlaceholderImg;
            }}
          />
        </div>
        <div className={styles.equipmentContent}>
          <div className={styles.equipmentName}>
            {item.model}
            {item.type && (
              <span className={`${styles.badge} ${styles[item.type.toLowerCase()]}`}>
                {item.type}
              </span>
            )}
          </div>
          <div className={styles.equipmentQuantity}>
            X {item.quantity}
          </div>
        </div>
      </div>
      <div className={styles.equipmentPrice}>
        {formatCurrency(item.price)}
      </div>
    </div>
  </div>
);

const TotalRow = ({ label, amount }) => (
  <div className={styles.detailItem}>
    <div className={styles.detailValue}>
      <span className={styles.totalLabel}>{label}</span>
      <span className={styles.totalValue}>
        {formatCurrency(amount)}
      </span>
    </div>
  </div>
);

const Equipment = ({ formik, onEdit, isOpen, onToggle }) => {
  // For now, we'll use mock data instead of formik values
  const { purchases, monthlyCosts, tppHardware } = MOCK_DATA;

  // Calculate totals from mock data
  const purchaseTotal = purchases.reduce((total, item) => total + (item.price * item.quantity), 0);
  const monthlyTotal = monthlyCosts.reduce((total, item) => total + (item.price * item.quantity), 0);
  const tppTotal = tppHardware.reduce((total, item) => total + (item.price * item.quantity), 0);

  return (
    <div className={styles.equipment}>
      <ReviewHeader
        title="Equipment"
        isOpen={isOpen}
        onToggle={onToggle}
        onEdit={onEdit}
      />

      {isOpen && (
        <div className={styles.content}>
          {purchases.length > 0 && (
            <div className={styles.section}>
              <SectionHeader title="PURCHASES" />
              <div className={styles.detailsGrid}>
                {purchases.map((item, index) => (
                  <EquipmentItem key={index} item={item} />
                ))}
                <TotalRow label="Total Purchase Amount" amount={purchaseTotal} />
              </div>
            </div>
          )}

          {monthlyCosts.length > 0 && (
            <div className={styles.section}>
              <SectionHeader title="MONTHLY COSTS" />
              <div className={styles.detailsGrid}>
                {monthlyCosts.map((item, index) => (
                  <EquipmentItem key={index} item={item} />
                ))}
                <TotalRow label="Total Monthly Cost" amount={monthlyTotal} />
              </div>
            </div>
          )}

          {tppHardware.length > 0 && (
            <div className={styles.section}>
              <SectionHeader title="TPP HARDWARE" />
              <div className={styles.detailsGrid}>
                {tppHardware.map((item, index) => (
                  <EquipmentItem key={index} item={item} />
                ))}
                <TotalRow label="Total TPP Hardware" amount={tppTotal} />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Equipment; 